import { createReducer } from "typesafe-actions";

import {
  Actions,
  createSandboxConfig,
  deleteSandboxConfig,
  initSandboxPage,
  updateSandboxConfig,
} from "./actions";

export interface SandboxState {
  hasIntegration: boolean;
  loading: boolean;
}

const initialState: SandboxState = {
  hasIntegration: false,
  loading: false,
};

const sandbox = createReducer<SandboxState, Actions>(initialState)
  .handleAction(initSandboxPage.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(initSandboxPage.success, (state, { payload: { hasIntegration } }) => ({
    ...state,
    hasIntegration,
    loading: false,
  }))
  .handleAction(initSandboxPage.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(createSandboxConfig.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(createSandboxConfig.success, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(createSandboxConfig.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(updateSandboxConfig.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(updateSandboxConfig.success, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(updateSandboxConfig.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(deleteSandboxConfig.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(deleteSandboxConfig.success, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(deleteSandboxConfig.failure, (state) => ({
    ...state,
    loading: false,
  }));

export * from "./selectors";
export type SandboxActions = Actions;
export default sandbox;
